import React from "react";

import "./index.scss";

const FieldRow = ({ fields }) => {
  return (
    <div className="field-row">
      {fields.map((field, index) => (
        <div key={index} className="field-cell">
          <div className="field-label">{field.label}</div>
          <div className="field-value">{field.value || null}</div>
        </div>
      ))}
    </div>
  );
};

export default FieldRow;
